<template>
  <div class="header-container">
    <div class="header-container-box">
      <div class="header-container-box-logo">
        <!-- <img
          src="https://image.bookgo.com.cn/bgOfficial/home/home-index-logo.png"
          alt="博库信息技术--logo"
          id="logo"
        /> -->
        <i class="iconfont iconbokulogo-copy"></i>
      </div>
      <div class="header-container-box-list">
        <ul class="header-container-box-list-ul">
          <li
            class="header-container-box-list-home"
            @click="$router.push('/')"
            @mouseover="
              showTab = false;
              showOtherTab = false;
            "
          >
            首页
          </li>
          <li
            @mouseover="
              showTab = true;
              showOtherTab = false;
            "
          >
            智慧图书馆
          </li>
          <li
            @mouseover="
              showOtherTab = true;
              showTab = false;
            "
          >
            图书馆特色方案
          </li>
          <li
            @click="$router.push({ name: 'dynamic-center' })"
            @mouseover="
              showTab = false;
              showOtherTab = false;
            "
          >
            动态中心
          </li>
          <li @click="$router.push({ name: 'customer-case' })">
            客户案例
          </li>
          <li @click="$router.push({ name: 'contact' })">
            联系合作
          </li>
          <li
            class="header-container-box-list-aboutus"
            @click="$router.push({ name: 'aboutus' })"
          >
            关于我们
          </li>
        </ul>
        <div class="header-container-tab" v-if="showTab">
          <div class="header-container-tab-selection">
            <div
              class="header-container-tab-selection-scene"
              :class="{ 'tab-active': isActive }"
              @click="isActive = true"
            >
              图书馆场景方案
            </div>
          </div>
          <div class="header-container-tab-sceneContent" v-if="isActive">
            <ul>
              <li
                class="header-container-tab-sceneContent-ele"
                v-for="(item, i) in selection"
                :key="i"
                @click="
                  $router.push(item.path);
                  showTab = false;
                "
              >
                <div class="header-pic-box">
                  <img :src="item.img" alt="" />
                </div>

                <h2>{{ item.title }}</h2>
                <p :title="item.desc">{{ item.desc }}</p>
              </li>
            </ul>
          </div>
          <div class="header-container-tab-specialContent" v-else>
            <ul>
              <li
                class="header-container-tab-specialContent-ele"
                v-for="(item, i) in selection_ele"
                :key="i"
                @click="$router.push(item.path)"
              >
                <img :src="item.img" alt="" />
                <h2>{{ item.title }}</h2>
                <p>{{ item.desc }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="header-container-tab1" v-if="showOtherTab">
          <div class="header-container-tab1-selection">
            <div
              class="header-container-tab1-selection-special tab-active"
              @click="isActive = false"
            >
              图书馆特色方案
            </div>
          </div>
          <div class="header-container-tab1-specialContent">
            <ul>
              <li
                class="header-container-tab1-specialContent-ele"
                v-for="(item, i) in selection_ele"
                :key="i"
                @click="
                  $router.push(item.path);
                  showOtherTab = false;
                "
              >
                <div class="header-pic-box">
                  <img :src="item.img" alt="" />
                </div>

                <h2>{{ item.title }}</h2>
                <p :title="item.desc">{{ item.desc }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: true,
      showTab: false,
      showOtherTab: false,
      flag: null,
      selection: [
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide1.png",
          title: "智慧图书馆",
          desc: "管理、服务、空间、馆舍四个智慧化建设",
          path: "/scene/totalSolution",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide2.png",
          title: "RFID图书馆",
          desc: "覆盖图书馆全流程、追求高效、便捷、体验",
          path: "/scene/RFID",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide3.png",
          title: "图书馆总分馆",
          desc: "总分双系统架构、通借通还、数据化管理",
          path: "/scene/headBranch",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide4.png",
          title: "泛在图书馆",
          desc: "不受时间、空间、地域限制享受图书馆服务",
          path: "/scene/Ubiquitous",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide5.png",
          title: "感知图书馆",
          desc: "建立管理、服务、安全、读者感知等数据模型",
          path: "/scene/toFeel",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide6.png",
          title: "互动图书馆",
          desc: "推动互动化、虚拟化、趣味化、多样化时代",
          path: "/scene/interact",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide7.png",
          title: "图书馆物联网",
          desc: "集中智能管控、数据化精细管理、降低运营成本",
          path: "/scene/webthings",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slide8.png",
          title: "图书馆防疫",
          desc: "消毒杀菌、口罩测温、预约系统全方位防疫",
          path: "/scene/antiepidemic",
        },
      ],
      selection_ele: [
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slides1.png",
          title: "公共图书馆",
          desc: "新技术新视觉新窗口全方位展示",
          path: "/special/public",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slides2.png",
          title: "中小学图书馆",
          desc: "用新技术打造新一代书香校园",
          path: "/special/primaryschool",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slides3.png",
          title: "高校图书馆",
          desc: "线下泛在阅读服务和线上云端图书馆平台服务",
          path: "/special/highschool",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slides4.png",
          title: "企事业图书馆",
          desc: "建设学习型企业、以文化管企业、兴企业",
          path: "/special/enterprise",
        },
        {
          img:
            "https://image.bookgo.com.cn/bgOfficial/header/header-slides5.png",
          title: "城市书房",
          desc: "用物联网、大数据等打造的智能24h阅读空间",
          path: "/special/city",
        },
      ],
    };
  },
  mounted() {
    let _this = this;
    document.addEventListener("click", function(e) {
      // 下面这句代码是获取 点击的区域是否包含你的菜单，如果包含，说明点击的是菜单以外，不包含则为菜单以内
      let flag = e.target.contains(
        document.getElementsByClassName("header-container-tab")[0]
      );
      let flag1 = e.target.contains(
        document.getElementsByClassName("header-container-tab1")[0]
      );

      if (!flag) {
        _this.showTab = false;
      }
      if (!flag1) {
        _this.showOtherTab = false;
      }
    });
  },
  methods: {
    // debounce(fn, wait) {
    //   if(this.fun!==null) {
    //     clearTimeout(this.fun)
    //   }
    //   this.fun = setTimeout(fn, wait);
    // },
    // handleLeave() {
    //   this.flag = null;
    //   if (this.flag !== null) {
    //     clearTimeout(this.flag);
    //   }
    //   this.flag = setTimeout(() => {
    //     this.showTab = false;
    //     this.showOtherTab = false;
    //   }, 2000);
    // },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/Header.scss";
</style>
